import { Typography as AntdTypography } from 'antd';
import { createGuardedComponent } from '../../provider/create-guarded-component';

export type { TypographyProps } from 'antd';

export const Typography = createGuardedComponent(AntdTypography) as typeof AntdTypography;
